import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

import StoreLayout from './components/StoreLayout';
import AdminLayout from './components/AdminLayout';

import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Checkout from './pages/Checkout';
import Orders from './pages/Orders';
import OrderConfirmation from './pages/OrderConfirmation';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import Chatbot from './components/Chatbot';

import { client } from './lib/appwrite';

function App() {
  React.useEffect(() => {
    client.ping()
      .then(() => console.log('Appwrite connected successfully'))
      .catch((err) => console.error('Appwrite connection failed:', err));
  }, []);

  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <Routes>
            {/* Storefront Layout Routes */}
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/order-confirmation" element={<OrderConfirmation />} />
              <Route path="/profile" element={<Profile />} />
            </Route>

            {/* Admin Layout Routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/products" replace />} />
              <Route path="products" element={<Admin activeTabOverride="products" />} />
              <Route path="orders" element={<Admin activeTabOverride="orders" />} />
              <Route path="payments" element={<Admin activeTabOverride="payments" />} />
              <Route path="users" element={<Admin activeTabOverride="users" />} />
              <Route path="reports" element={<Admin activeTabOverride="reports" />} />
            </Route>
          </Routes>
          <Chatbot />
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;